import React, {memo} from 'react';
import QADatasetBuilder from "../Components/tools/QADatasetBuilderComponent";

function QADatasetBuilderPage() {

	return (
		<>
			<QADatasetBuilder />
		</>
	);
}

export default memo(QADatasetBuilderPage);